export default __webpack_public_path__ + "static/media/unit.f32d7d9d.svg";